import { produce } from 'immer';
import { UsersState } from '../../usersgroups/usergroup-types';
import {
  FETCH_USER_SUCCESS,
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  DEACTIVATE_USER_REQUEST,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAILURE,
  REACTIVATE_USER_REQUEST,
  REACTIVATE_USER_SUCCESS,
  REACTIVATE_USER_FAILURE,
  LOGOUT_DEVICE_REQUEST,
  UPDATE_USER_INFO,
  UPDATE_SELECTED_GROUPS,
  RE_ADD_GROUP,
  REMOVE_CURRENT_GROUP,
  FETCH_USER_FAILURE,
  FETCH_USER_REQUEST,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  FETCH_USER_DETAILS_FAILURE,
  LOGOUT_DEVICE_SUCCESS,
  LOGOUT_DEVICE_FAILURE
} from './actions';

function initializeListState(): UsersState {
  return {
    users: [],
    userCount: 0,
    isFetching: false,
    isAdmin: false,
    confirmDeactivateUserId: null
  } as unknown as UsersState;
}

function initializeUserState(previousState: UsersState): UsersState {
  return {
    breadcrumbs: previousState?.groupList?.breadcrumbs ? previousState?.groupList?.breadcrumbs : [],
    password: '',
    confirmPassword: '',
    error: '',
    displayName: '',
    emailAddress: '',
    clientId: '',
    groupId: '',
    groupName: '',
    id: '',
    userName: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    active: true,
    isAdmin: false,
    selectedGroupIds: [],
    allGroups: [],
    groups: [],
    Devices: [],
    isFetching: false
  } as unknown as UsersState;
}

function getUserList(userListState: UsersState = initializeListState(), data, append) {
  if (append) {
    const users = userListState.users.concat(data.users);
    const updated = { ...userListState, ...data };
    updated.users = users;
    return updated;
  }
  return { ...userListState, ...data };
}

function updateGroupsToAdd(state, payload, action) {
  const currentGroups = state.groups;
  for (const g of currentGroups) {
    if (g.id === payload.groupId) {
      if (action === 'remove') g.isRemoved = true;
      else if (action === 'add') g.isRemoved = false;
    }
  }
  state.groups = currentGroups;
  state.error = '';
  return state;
}

function removeDeviceFromState(state, data) {
  const devices = state.devices;
  const i = devices.findIndex((device) => {
    return device.id === data.deviceId;
  });
  devices.splice(i, 1);
  state.devices = devices;
  state.error = '';
  return state;
}

export default function (state: UsersState = initializeListState(), action): UsersState {
  if (!action) {
    return state;
  }

  return produce(state, (draft) => reduce(draft, action));
}

function reduce(state: UsersState = initializeListState(), action): UsersState {
  switch (action.type) {
    case FETCH_USER_SUCCESS:
      const updated = getUserList(state, action.payload, action.append);
      updated.isFetching = false;
      return updated;
    case FETCH_USER_DETAILS_REQUEST:
      return { ...initializeUserState(state), ...action.payload };
    case FETCH_USER_DETAILS_SUCCESS:
      const newState = { ...state, ...action.payload };
      newState.originalUserName = action.payload.userName;
      newState.isFetching = false;
      newState.error = '';
      newState.selectedGroupIds = [];
      return newState;
    case DEACTIVATE_USER_REQUEST:
      if (action.payload.inList) return { ...state, ...action.payload, error: '' };
      state.active = false;
      state.error = '';
      return state;
    case DEACTIVATE_USER_SUCCESS: {
      const users = state.users;
      if (users) {
        const deactivateIndex = users.findIndex((user) => user.id === action.payload.userId);
        const activeUserCount = state.activeUserCount;
        state.users[deactivateIndex].active = false;
        state.activeUserCount = activeUserCount - 1;
      }
      return state;
    }
    case DEACTIVATE_USER_FAILURE:
      if (action.payload.inList) return { ...state, ...action.payload, error: action.payload.error };
      state.active = true;
      state.error = action.payload.error;
      return state;
    case REACTIVATE_USER_REQUEST:
      if (action.payload.inList) return { ...state, ...action.payload, error: '' };
      state.active = true;
      state.error = '';
      return state;
    case REACTIVATE_USER_SUCCESS: {
      const reactivateIndex = state.users.findIndex((user) => user.id === action.payload.userId);
      const activeUserCount = state.activeUserCount;
      state.users[reactivateIndex].active = true;
      state.activeUserCount = activeUserCount + 1;
      return state;
    }
    case REACTIVATE_USER_FAILURE:
      if (action.payload.inList) return { ...state, ...action.payload, error: action.payload.error };
      state.active = false;
      state.error = action.payload.error;
      return state;
    case LOGOUT_DEVICE_REQUEST:
      return removeDeviceFromState(state.Devices, action.payload);
    // return state.update('Devices', (userListState) => removeDeviceFromState(userListState, action.payload));
    case UPDATE_USER_INFO:
      return { ...state, ...action.payload, error: '' };

    case UPDATE_SELECTED_GROUPS:
      state.selectedGroupIds = action.payload.groupIds;
      state.error = '';
      return state;
    case RE_ADD_GROUP:
      return updateGroupsToAdd(state, action.payload, 'add');
    case REMOVE_CURRENT_GROUP:
      return updateGroupsToAdd(state, action.payload, 'remove');

    case FETCH_USER_FAILURE:
    case FETCH_USER_REQUEST:
    case UPDATE_USER_REQUEST:
    case UPDATE_USER_SUCCESS:
    case UPDATE_USER_FAILURE:
    case FETCH_USER_DETAILS_FAILURE:
    case LOGOUT_DEVICE_SUCCESS:
    case LOGOUT_DEVICE_FAILURE:
      return { ...state, ...action.payload };

    default:
      return state;
  }
}
